import { ChangeDetectionStrategy, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile.service';
import { NgIf, NgFor, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-manage-saved-bulletins',
    templateUrl: './manage-saved-bulletins.component.html',
    styleUrls: ['./manage-saved-bulletins.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgFor,
        RouterLink,
        FormsModule,
        NgStyle,
    ],
})
export class ManageSavedBulletinsComponent implements OnInit, OnDestroy {

  @ViewChild('addNewBulletinModal')
  addNewBulletinModal: ElementRef;

  private subscriptions: ISubscription[];
  savedBulletinGroups: any[];
  savedBulletins: any[];
  savedBulletinGroupsList: any[];
  expandBulletinGroup = {};
  APP_SETTINGS:any;
  inputBulletinType: any;

  holdBulletinInfo: any;
  holdGroupInfo: any;

  public screenWidth: number;

  // ngModel variables
  newGroupName = '';
  groupName = '';
  bulletinId = '';
  userSelectedExistingGroup;
  changeGroupName = '';
  errorMessage = '';

  username: string;

  constructor(private userProfileService: UserProfileService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private utilityService: UtilityService) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.savedBulletinGroups = [];
    this.savedBulletinGroupsList = [];
    this.savedBulletins = [];
    this.subscriptions = [];
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.userProfileService.getListOfSavedBulletinGroups(this.username).subscribe(value => {
      this.savedBulletinGroupsList = value;
      this.fetchUserSavedBulletinGroups();
      this.fetchUserSavedBulletins();
      this.spinnerService.hide('bmwSpinner');
    }, error => {
      this.spinnerService.hide('bmwSpinner');
    }));

  }
  fetchUserSavedBulletinGroups() {
    this.subscriptions.push(this.userProfileService.getUserSavedBulletinGroupCategories(this.username).subscribe(data => {
      this.savedBulletinGroups = data;
    }, error => {
      this.spinnerService.hide('bmwSpinner');
    }));
  }
  fetchUserSavedBulletins() {
    this.subscriptions.push(this.userProfileService.getUserSavedBulletins(this.username).subscribe(data => {
      this.savedBulletins = data;
    }, error => {
      this.spinnerService.hide('bmwSpinner');
    }));
  }
  renameGroup(newGroupName) {
    if (newGroupName) {
      let bulletinGroupInfo = '';

      // fetch group info in groupsList with the title in holdGroupInfo object
      this.savedBulletinGroupsList.forEach(listItem => {
        if (listItem.groupName === this.holdGroupInfo.title) {
          bulletinGroupInfo = listItem;
        }
      });
      // rename group attribute with user entered value
      bulletinGroupInfo['groupName'] = newGroupName;
      this.spinnerService.show('bmwSpinner');
      this.subscriptions.push(this.userProfileService.renameSavedBulletinGroup(this.username, bulletinGroupInfo).subscribe(data => {
        this.fetchUserSavedBulletinGroups();
        this.fetchUserSavedBulletins();
        this.spinnerService.hide('bmwSpinner');
      }, error => {
        this.spinnerService.hide('bmwSpinner');
      }));
    }
  }
  deleteGroup(groupTitle) {
    let groupId = '';
    this.savedBulletinGroupsList.forEach(listItem => {
      if (listItem.groupName === groupTitle) {
        groupId = listItem.id;
      }
    });
    this.subscriptions.push(this.userProfileService.deleteSavedBulletinGroup(this.username, groupId).subscribe(data => {
      this.savedBulletinGroupsList = data;
      this.fetchUserSavedBulletinGroups();
    }));
  }
  deleteBulletin(bulletinId) {
    this.subscriptions.push(this.userProfileService.deleteSavedBulletin(this.username, bulletinId).subscribe(data => {
      this.fetchUserSavedBulletins();
    }));
  }
  moveBulletinToOtherGroup(bulletin) {
    return null;
  }
  deleteBulletinFromGroup(bulletinId) {
    this.subscriptions.push(this.userProfileService.deleteSavedBulletin(this.username, bulletinId).subscribe(data => {
      this.fetchUserSavedBulletinGroups();
    }));
  }
  addNewBulletinGroup(groupName) {
    if (groupName) {
      this.subscriptions.push(this.userProfileService.addNewBulletinGroup(this.username, groupName).subscribe(data => {
        // this.fetchUserSavedBulletinGroups();
      }));
    }
  }
  addNewBulletin(bulletinNumber) {
    if (bulletinNumber) {
      const bulletinId = bulletinNumber.replace(/\s+/g, "");
      this.userProfileService.findBulletinByNumber(bulletinId, this.inputBulletinType).subscribe(
        bulletinData => {
          this.subscriptions.push(this.userProfileService.addNewBulletin(
            this.username,
            bulletinId,
            this.inputBulletinType).subscribe(data => {
              this.addNewBulletinModal.nativeElement.click();
              this.errorMessage = '';
              this.fetchUserSavedBulletins();
            }));
        },
        error => {
          this.errorMessage = error.error.message;
        });
    }
  }
  addBulletinToNewOrExistingGroup(groupName, existingGroup) {
    if (groupName) {
      this.subscriptions.push(this.userProfileService.associateBulletinToNewGroup(this.username, this.holdBulletinInfo.id, groupName)
        .subscribe(data => {
          this.fetchUserSavedBulletinGroups();
          this.fetchUserSavedBulletins();
        }));
    } else if (existingGroup) {
      let bulletinGroupInfo = '';
      this.savedBulletinGroupsList.forEach(listItem => {
        if (listItem.groupName === existingGroup) {
          bulletinGroupInfo = listItem;
        }
      });
      this.subscriptions.push(this.userProfileService
        .associateBulletinToExistingGroup(this.username, this.holdBulletinInfo.id, bulletinGroupInfo['id'])
        .subscribe(data => {
          this.fetchUserSavedBulletinGroups();
          this.fetchUserSavedBulletins();
        }));
    }
  }
  holdBulletinToAddToNewGroup(bulletinInfo) {
    this.holdBulletinInfo = bulletinInfo;
  }
  holdGroupToRename(groupInfo) {
    this.holdGroupInfo = groupInfo;
    this.changeGroupName = groupInfo.title;
  }
  ngOnDestroy(): void {
    this.subscriptions.map(s => s.unsubscribe());
  }

}
